/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Field_Dest_PositionInputs */

const vi_pdc_field_dest_position = /** @type {(inputs: Pdc_Field_Dest_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí đích`)
};

/**

* @param {Pdc_Field_Dest_PositionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_field_dest_position = /** @type {((inputs?: Pdc_Field_Dest_PositionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Field_Dest_PositionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_field_dest_position(inputs)
});